import { createElement } from "react";
import { Head, usePage } from "@inertiajs/react";

type ServerMetaTag = {
  tagName: string;
  headKey: string;
  innerContent?: string;
  [key: string]: unknown;
};

/**
 * Keep Rails-owned metadata alive after hydration and update it on Inertia
 * navigation. Rails renders the same tags directly for crawlers; this component
 * is client-only so SSR does not duplicate them.
 */
export function ServerMetaHead() {
  const { props } = usePage();
  if (typeof window === "undefined") return null;

  const metaTags = Array.isArray(props._inertia_meta)
    ? props._inertia_meta as ServerMetaTag[]
    : [];

  return (
    <Head>
      {metaTags.map((metaTag) => {
        const { tagName, headKey, innerContent, ...attributes } = metaTag;
        const propsForElement = { ...attributes, "head-key": headKey, key: headKey };

        if (tagName === "script") {
          return createElement(tagName, {
            ...propsForElement,
            dangerouslySetInnerHTML: { __html: innerContent || "" },
          });
        }

        return createElement(tagName, propsForElement, innerContent);
      })}
    </Head>
  );
}
